<template>
    <CCard>
        <CCardHeader>
            <strong>Чеки</strong>
        </CCardHeader>
        <CCardBody>
            <CDataTable
                hover
                :items="filteredItems"
                :fields="fields">
                <template #created_at="data">
                    <td>
                        {{ formatDate(data.item.created_at) }}
                    </td>
                </template>
                <template #actions="data">
                    <td>
                        <a :href="data.item.link" target="_blank"><CIcon
                            :content="$options.icons.cilExternalLink"
                        /></a>
                    </td>
                </template>
            </CDataTable>
            <div>
                <CButton
                    color="primary"
                    class="mr-3"
                    @click="modalVisible = true">Добавить чек</CButton>
            </div>
        </CCardBody>
        <CModal
            title="Добавление чека"
            :show.sync="modalVisible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Тип чека</CCol>
                            <CCol>
                                <CSelect 
                                    v-model="receipt_type"
                                    :horizontal="true"
                                    :options="receiptTypes"
                                    placeholder="Тип чека"
                                    class="custom-filter-select w-full mb-0">
                                </CSelect>
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">ID чека</CCol>
                            <CCol>
                                <CInput 
                                    v-model="receipt_id" 
                                    placeholder="ID чека" 
                                />
                                <div style="color: #dc3545">{{ error }}</div>
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="addReceipt">Отправить</CButton>
                    <CButton color="light" @click="modalVisible = false">Отмена</CButton>
                </div>
            </template>
        </CModal>
    </CCard>
</template>

<script>
    import Vue from 'vue';
    const {
        paymentStatusTitle,
        paymentStatusBagde,
    } = require('../../utils/order-views');
    const { formatDate } = require('../../utils/views');
    import { cilExternalLink } from '@coreui/icons';

    export default {
        name: 'OrderReceipts',

        props: {
            order_id: {
                type: Number,
                default: () => null,
            },
            items: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                error: null,
                receipt_type: 1,
                receipt_id: null,
                isAuthorized: false,
                fields: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'title', label: 'Тип' },
                    { key: 'amount', label: 'Сумма' },
                    { key: 'created_at', label: 'Дата' },
                    { key: 'actions', label: '' },
                ],
                receiptTypes: [
                    { label: 'Чек предоплаты', value: 1 },
                    { label: 'Финальный чек', value: 2 },
                    { label: 'Чек отмены', value: 3 },
                ],
                paymentDetails: {},
                showDetails: false,
                modalVisible: false
            };
        },

        computed: {
            filteredItems() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin ? this.items : this.items.filter(item => { return !item.tips});
            }
        },

        icons: {
            cilExternalLink,
        },

        methods: {
            showDetailsDialog(paymentId) {
                for (var i = 0; i < this.items.length; i++) {
                    if (paymentId === this.items[i].id) {
                        this.paymentDetails = this.items[i];
                    }
                }
                this.showDetails = true;
            },
            paymentStatusTitle(status) {
                return paymentStatusTitle(status);
            },
            paymentStatusBagde(status) {
                return paymentStatusBagde(status);
            },
            formatDate(date) {
                return formatDate(date);
            },
            paymentType(data) {
                return data?.payload ? JSON.parse(data.payload).GatewayName : '';
            },
            paymentDetailsCode(details) {
                var code = '';
                if (details) {
                    try {
                        code = JSON.stringify(JSON.parse(details), null, 4);
                    } catch (err) {
                        // Nothing to do
                    }
                }
                return code;
            },
            async addReceipt() {
                this.error = null;
                const { data } = await Vue.axios.post(
                    `/orders/add-receipt`,
                    { 
                        order_id: this.order_id,
                        receipt_type: this.receipt_type,
                        receipt_id: this.receipt_id 
                    }
                );
                if(data.error) {
                    this.error = data.error;
                    return;
                }
                this.receipt_type = 1;
                this.receipt_id = null;
                this.modalVisible = false;
                location.reload();
            }
        },
    };
</script>

<style scoped>
</style>